module.exports = __webpack_public_path__ + "static/f_capabilities_3_4-9ba6e163a7279aefb4283f0f6083596f.png";